import { Component } from '@angular/core';

@Component({
  selector: 'app-service-term',
  templateUrl: './service-term.component.html',
  styleUrls: ['./service-term.component.scss']
})
export class ServiceTermComponent {
  scrollToSection(sectionId: string) {
    const section = document.getElementById(sectionId);
    if (!section) return;

    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
